<template>
  <div
    v-show="show"
    :class="computedWrapperCssClass"
    :style="computedWrapperCssStyle"
  >
    <slot>
      <form-validation
        :label="label"
        :id="identity"
        :name="name"
        :show="showValidation"
        :css-class="computedValidationCssClass"
        :validation="computedValidation"
        :error="error"
      ></form-validation>
    </slot>
    <div class="relative">
      <select
        :id="identity"
        :name="name"
        :disabled="isDisabled"
        :autocomplete="autocomplete"
        :class="inputCssClass"
        class="block select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        v-focus="focus"
        v-model="selected"
        @change="update"
      >
        <option v-if="placeholder" v-text="placeholder" value></option>
        <option
          v-for="option in records"
          :key="option.value"
          :value="option.value"
          v-text="option.name"
        ></option>
      </select>
    </div>
  </div>
</template>
<script>
import BaseSingleSelect from '@ssdcode/vue-form/src/components/Form/Inputs/Select/BaseSingleSelect';
export default {
  mixins: [BaseSingleSelect],
};
</script>
